import React, { forwardRef } from 'react';
import { Link } from 'react-router-dom';

// eslint-disable-next-line no-unused-vars
const LinkRef = ({ ...props }, ref) => {
  return <Link {...props} />;
};

export default forwardRef(LinkRef);
